<template>
  <div v-if="list" class="layer versionHistory">
    <button type="button" class="btnClose" @click="cancel"></button>
    <div class="inner">
      <h2 class="layerTitle">{{locale.versionhistory}}</h2>
      <p class="colorGrey mb15">{{locale.keep_version_maximum}}</p>
      <div class="table">
        <table>
          <thead>
            <tr>
              <th>{{locale.version}}</th>
              <th>{{locale.memo}}</th>
              <th class="center">{{ locale.state }}</th>
              <th class="center">{{locale.writer}}</th>
              <th class="center">{{locale.table_createat}}</th>
            </tr>
          </thead>
          <tbody v-if="list.length">
            <tr v-for="(item, index) in list"
              :key="index"
              :class="{current: isCurrent(item.version)}">
              <td class="version" @click="load(item.version)">
                <span class="no" :class="{current: isCurrent(item.version)}">{{item.version}}</span>
                <span class="btn btnWhite sizeXs ml15">{{locale.load}}</span>
              </td>
              <td v-html="item.comment"></td>
              <td class="center">
                <!-- <span v-if="currentVer === item.version" class="stkr current">{{locale.stkr_current}}</span>
                <span v-if="parseInt(item.version) === list.length" class="stkr published">{{locale.stkr_published}}</span> -->
                <span v-if="isCurrent(item.version)" class="stkr current">{{ locale.stkr_current }}</span>
                <span v-if="isLast(item.version)" class="stkr published">{{ locale.stkr_published }}</span>
              </td>
              <td class="center">{{item.user}}</td>
              <td class="center date">{{date(item.createat)}}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="noData center" colspan="5">{{locale.nodata_version}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="cancel">{{ locale.cancel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import DATE from '@/common/date'

export default {
  name: 'VersionHistory',
  props: [
    'locale',
    'file',
    'currentVer'
  ],
  async created () {
    const file = this.file
    this.$store.commit('onLoading', true)
    await this.$store.dispatch('versionhistory/getFileVersion', { file: file }).then((res) => {
      if (res && res.data) {
        this.list = res.data.map(x => {
          return {
            createat: x.createat,
            version: x.version,
            user: x.userid,
            comment: x.comment
          }
        }).sort((a, b) => {
          return a.version > b.version ? -1 : a.version < b.version ? 1 : 0
        })
      }
      this.$store.commit('onLoading', false)
    })
    this.$store.commit('onLoading', false)
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    date (date) {
      return DATE.toString(date)
    },
    isCurrent (version) {
      return parseInt(this.currentVer || 0) === parseInt(version)
    },
    isLast (version) {
      const last = this.list[0]
      return parseInt(last.version) === parseInt(version)
    },
    load (version) {
      if (window.confirm(`${this.locale.confirm_load_version}\n${this.locale.page_contents_will_change}`)) {
        this.$emit('load', version)
      }
    },
    cancel () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.close()
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.versionHistory {
  > .inner {
    max-width: 860px;
  }
  .table {
    background-color: $color-white;
    thead,
    tbody {
      display: block;
    }
    thead {
      border-top: 1px solid $color-lgrey2;
    }
    tbody {
      max-height: 600px;
      overflow-y: auto;
    }
    tr {
      display: flex;
      align-items: center;
      border-bottom: 1px solid $color-lgrey2;
      background-color: $color-white;
    }
    th,
    td {
      border: none;
      background: none;
      &:nth-of-type(1) {
        flex: 1;
        padding-left: 30px;
      }
      &:nth-of-type(2) {
        width: 240px;
      }
      &:nth-of-type(3) {
        width: 100px;
      }
      &:nth-of-type(4) {
        width: 100px;
      }
      &:nth-of-type(5) {
        width: 100px;
      }
    }
    tr.current {
      background-color: rgba($color-green, 0.1);
    }
    .noData {
      padding-top: 80px;
      padding-bottom: 80px;
    }
  }
  .version {
    padding-left: 30px;
    cursor: pointer;
    &:hover .no {
      color: $color-blue;
      text-decoration: underline;
    }
    .btn {
      border-radius: 4px;
    }
  }
  .stkr {
    // display: block;
    // width: 24px;
    // height: 24px;
    // margin: 2px auto;
    // border-radius: 100%;
    // opacity: 0.75;
    // &.current {
    //   background: $color-green url('~@/assets/img/ico_show_wh.png') 50% 50% / 16px no-repeat;
    // }
    // &.published {
    //   background: $color-primary url('~@/assets/img/ico_publish_wh.png') 50% 50% / 16px no-repeat;
    // }
    display: inline-block;
    margin: 2px 0;
    padding: 2px 4px;
    font-size: 10px;
    color: #fff;
    white-space: nowrap;
    border-radius: 4px;
    background-color: $color-green;
    &.published {
      background-color: $color-primary;
    }
  }
  .btns {
    margin: 30px auto 0;
    text-align: center;
  }
}
</style>
